module.exports = __webpack_public_path__ + "images/_/programs/keepCool/images/characters/apprenticeArmsFolded2-d85327598c4b416d7264a69b386051a0.png";


//////////////////
// WEBPACK FOOTER
// ./programs/keepCool/images/characters/apprenticeArmsFolded2.png
// module id = 2429
// module chunks = 2